import $ from "jquery"
import TemplateView from "../../TemplateView"
import AuditHistoryView from "../auditHsitory/AuditHistoryView"
import messageResource from "../../messageResource"
import ResizableInput from "../ResizableInput"
import TaskStore from "../../store/TaskStore"
import ProgressBar from "../../controls/task/ProgressBar"
import TaskStatusButton from "../../controls/task/TaskStatusButton"
import {Feature, isEnabled} from '../../features/index'
import {selectFakeStatusIdByTaskComplete, selectStatusIdByTask} from '../../workflowStatus/selectors'
import CommentsSection from './CommentsSection'
import TimeEditor from '../../controls/task/TimeEditor'
import TaskStatusMenu from '../../controls/task/TaskStatusMenu'
import {Description} from '../Description'
import ClassicBridge from '../../next/ClassicBridge'
import {setEventPreventHidingAllPanels} from '../utils'

export default class TaskPanelDetails extends TemplateView {
    constructor({
        editable,
        showComments = false,
        dateFormat,
        scrollToElementCb = () => {},
        refreshScrollCb = () => {},
        onStatusChangedCb = () => {},
        onDeadlineChangedCb = () => {},
        onTypeOfWorkChangedCb = () => {},
        onEstimateChangedCb = () => {},
        onDescriptionChangeCb = () => {},
        onCustomFieldChangeCb = () => {},
        loadAuditHistoryCb = () => {},
        onHistoryClickCb = () => {},
    }) {
        super()

        this.params = {
            dateFormat,
            showComments,
        }

        this.state = {
            id: 0,
            canReopenProject: false,
            canEditTaskStatus: true,
            taskEstimatedTime: 0,
            taskSpentTime: 0,
            taskDescription: '',
            typeOfWork: {
                id: 0,
                name: '',
                billable: false,
            },
            typesOfWork: [],
            completed: false,
            workflowStatusId: 0,
            deadline: null,

            taskDescriptionLoading: false,
            deadlineLoading: false,
            typeOfWorkLoading: false,
            estimateLoading: false,
            statusLoading: false,

            editable: editable,

            isBTYEnabled: false,
            isTWSEnabled: false,
            isESTEnabled: false,

            auditActions: [],
            auditDependencies: [],
            lastAuditActions: {
                createAction: null,
                updateAction: null,
            },
            allAuditHistoryLoaded: false,

            customFields: [],
            customFieldsValues: {},
            readonlyFields: [],
        }

        this.callbacks = {
            scrollToElementCb,
            refreshScrollCb,
            onStatusChangedCb,
            onDeadlineChangedCb,
            onEstimateChangedCb,
            onTypeOfWorkChangedCb,
            onDescriptionChangeCb,
            onCustomFieldChangeCb,
            loadAuditHistoryCb,
            onHistoryClickCb,
        }

        this.onStatePropertyChanged('editable', editable => {
            this.description.setState({
                editable: editable,
                placeholder: !editable ? messageResource.getMessage('panel.common.description.no_description')
                                       : messageResource.getMessage('task.edit_panel.description.empty')
            })
            this.estimatedTimeEditor.setEditable(editable)
        })

        this.onStatePropertyChanged('canEditTaskStatus', canEditTaskStatus  => {
            if (this.taskStatusButton && this.taskStatusButton.setEditable) {
                this.taskStatusButton.setEditable(canEditTaskStatus)
            }
        })


        this.onStatePropertyChanged('canReopenProject', (canReopenProject) => {
            this.taskStatusButton.setState({
                canReopenProject
            })
        })

        this.onAnyStatePropertyChanged(['taskEstimatedTime', 'isESTEnabled'], ({taskEstimatedTime, isESTEnabled}) => {
            this.estimatedTimeEditor.setTime(isESTEnabled ? taskEstimatedTime : null)
            this.progressBar.setEstimatedTime(taskEstimatedTime)
            this.progressBar.update()
        })

        this.onStatePropertyChanged('taskSpentTime', time => {
            this.progressBar.setSpentTime(time)
            this.progressBar.update()
        })

        this.onStatePropertyChanged('taskDescription', description => {
            this.description.setState({text: description})
        })

        this.onStatePropertyChanged('typesOfWork', (typesOfWork) => {
            this.integratedDetails.setProps({
                typesOfWork
            })
        })

        this.onStatePropertyChanged('typeOfWork', (typeOfWork) => {
            this.integratedDetails.setProps({
                typeOfWorkId: typeOfWork.id
            })
        })

        this.onAnyStatePropertyChanged(['completed', 'workflowStatusId', 'isTWSEnabled'], state => {
            const isTWSEnabled = state.isTWSEnabled
            this.taskStatusButton.setState({
                statusId: isTWSEnabled ? state.workflowStatusId : selectFakeStatusIdByTaskComplete(state.completed)
            })
        })

        this.onStatePropertyChanged('deadline', date => {
            this.integratedDetails.setProps({
                deadlineDate: date
            })
        })

        this.onStatePropertyChanged('taskDescriptionLoading', loading => this.description.setState({loading}))
        this.onStatePropertyChanged('deadlineLoading', loading => {})
        this.onStatePropertyChanged('typeOfWorkLoading', loading => {})
        this.onStatePropertyChanged('estimateLoading', loading => this.estimatedTimeEditor.setLoading(loading))
        this.onStatePropertyChanged('statusLoading', loading => this.taskStatusButton.setLoading(loading))

        this.onStatePropertyChanged('isBTYEnabled', enabled => {
            this.integratedDetails.setProps({
                typeOfWorkEditorAvailable: enabled
            })
        })

        this.onStatePropertyChanged('isESTEnabled', enabled => {
            this.$estimateSection.toggle(enabled)
        })

        this.onStatePropertyChanged('lastAuditActions', actions => {
            this.setAuditHistory(actions.createAction, actions.updateAction)
        })

        this.onStatePropertyChanged('auditActions', (actions, oldActions) => {
            this.setAuditRecords(actions)
            //            this.addAuditRecords(actions.slice(actions.length - oldActions.length, actions.length))
        })

        this.onStatePropertyChanged('allAuditHistoryLoaded', allAuditHistoryLoaded => {
            this.auditHistory.setState({allAuditHistoryLoaded})
        })

        this.onAnyStatePropertyChanged(['customFields', 'customFieldsValues'], (state) => {
            this.integratedDetails.setProps({
                customFields: state.customFields,
                customFieldsValues: state.customFieldsValues
            })
        })

        this.onStatePropertyChanged('readonlyFields', (readonlyFields) => {
            this.integratedDetails.setProps({
                readonlyFields
            })
        })
    }

    templateHtml() {
        return "<div class='detailsTab panelTab'>" +
               " <div class='detailsSection section'>" +
               "     <div class='auditHistoryPlaceholder'/>" +
               "     <div class='detailsHeader sectionHeader'><%=details%></div>" +
               "     <div class='detailsRow'>" +
               "         <div class='statusCell'><div class='cellHeader'><%=status%></div><div class='cellButton'/></div>" +
               "         <div class='atNextTaskTableDetailsMountPoint atNextMount'></div>" +
               "     </div>" +
               " </div>" +
               " <div class='estimateSection section'>" +
               "     <div class='estimateHeader sectionHeader'><%=estimate%></div>" +
               "     <div class='collapseButton'/>" +
               "     <div class='estimateRow'>" +
               "         <div class='estimatedHours'><%=estimatedHours%>:</div>" +
               "         <div class='estimatedTimeWrapper'/>" +
               "         <div class='progress'/>" +
               "     </div>" +
               " </div>" +
               " <div class='descriptionSection section'>" +
               "  <div class='title sectionHeader'><%=description%></div>" +
               "  <div class='description'></div>" +
               " </div>" +
               " <div class='commentsSectionPlaceholder'/>" +
               "</div>"
    }

    shouldUpdateOnInit() {
        return false
    }

    afterRender() {
        this.$detailsRow = this.find(".detailsRow")

        this.auditHistory = new AuditHistoryView({
            extraClass: 'taskAudit',
            loadAuditRecordsCb: this.callbacks.loadAuditHistoryCb,
            onHistoryClickCb: this.callbacks.onHistoryClickCb,
        }).init(this.find('.auditHistoryPlaceholder'))
        const $statusCellButton = this.find('.statusCell .cellButton')
        this.taskStatusButton = new TaskStatusButton({
            editable: true,
            showStatusTypePrefix: isEnabled(Feature.TWS),
            positionParams: {
                offset: "0px 1px",
                within: this.$el,
                collision: 'fit',
            },
            onStatusChangedCb: this.callbacks.onStatusChangedCb,
            taskStatusMenu: new TaskStatusMenu($statusCellButton).init(),
        }).init($statusCellButton)
        this.auditHistory.setDateFormat(this.params.dateFormat)

        this.$descriptionSection = this.find('.descriptionSection')
        this.$description = this.find(".description")
        this.description = new Description({
            onChange: this.callbacks.onDescriptionChangeCb,
        }).init(this.$description)
        this.description.setState({
            placeholder: messageResource.getMessage('task.edit_panel.description.empty'),
            editable: this.state.editable
        })

        this.$estimateSection = this.find(".estimateSection")
        this.estimatedTimeEditor = new TimeEditor(this.find('.estimatedTimeWrapper'), this.state.editable,
            messageResource.getMessage('task.time_editor_placeholder.enter_hours'),
            messageResource.getMessage('task.time_editor_placeholder.not_defined'),
            this.callbacks.onEstimateChangedCb).init()

        let $clearButton = $("<div class='clearButton'/>")
        this.estimatedTimeEditor.$el.append($clearButton)
        $clearButton.click(() => {
            this.estimatedTimeEditor._triggerChange(null)
        })

        this.progressBar = new ProgressBar(this.find('.progress')).init()
        this.estimatedTimeEditor.on('change', (e, time) => {
            this.progressBar.setEstimatedTime(time)
            this.progressBar.update()
        })

        const commentsSection = new CommentsSection({
            refreshScrollCb: this.callbacks.refreshScrollCb,
            scrollToElementCb: this.callbacks.scrollToElementCb
        }).init(this.find('.commentsSectionPlaceholder'))
        commentsSection.toggle(this.params.showComments)

        const $detailsMountPoint = this.find('.atNextTaskTableDetailsMountPoint')
        this.integratedDetails = ClassicBridge.integrateTaskPanelDetails($detailsMountPoint[0])
        this.integratedDetails.setProps({
            onChangeDeadlineDate: (date) => this.callbacks.onDeadlineChangedCb(date),
            onChangeTypeOfWork: (towId) => this.callbacks.onTypeOfWorkChangedCb(towId),
            onChangeCustomField: (field, value) => this.callbacks.onCustomFieldChangeCb(field, value)
        })
        $detailsMountPoint.click((e) => setEventPreventHidingAllPanels(e))

        this.renderInitialState()
    }

    messageKeys() {
        return {
            description: "task.edit_popup.task_description",
            details: 'task.edit_panel.sections.details',
            status: 'common.status',
            workType: 'task.edit_popup.task_billing_type',
            estimate: 'task.edit_panel.sections.estimate',
            estimatedHours: 'task.edit_popup.task_estimated_hours'
        }
    }

    update() {
        const task = TaskStore.get(this.state.id)
        this.taskStatusButton.setState({
            statusId: selectStatusIdByTask(task)
        })
        this.taskStatusButton.setEditable(this.state.editable)
        this.$estimateSection.toggle(this.state.isESTEnabled)
        this.estimatedTimeEditor.setTime(this.state.isESTEnabled ? task['estimatedTime'] : null)
        this.progressBar.setEstimatedTime(task['estimatedTime'])
        this.progressBar.update()
        this.description.setState({
            editable: this.state.editable,
            placeholder: !this.state.editable ? messageResource.getMessage('panel.common.description.no_description')
                                              : messageResource.getMessage('task.edit_panel.description.empty')
        })
    }

    hideSelectors() {
        // empty
    }

    clearAuditHistory() {
        this.auditHistory.hide()
    }

    setAuditHistory(createAction, lastUpdateAction) {
        this.auditHistory.setAuditActions(createAction, lastUpdateAction, [])
    }

    addAuditRecords(auditRecords, dependencies) {
        this.auditHistory.addRecords(auditRecords, dependencies)
    }

    setAuditRecords(auditRecords) {
        this.auditHistory.setRecords(auditRecords)
    }

    hideAuditHistoryMenu() {
        this.auditHistory.auditHistoryMenu.hide()
    }

    setSelectorsDisabled(disabled) {
        this.taskStatusButton.setDisabled(disabled)
    }

    setDescription(description) {
        this.description.setState({text: description})
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/task/TaskPanelDetails.js